import React, { useState, useEffect } from "react";
import api from "../../services/api";

function DmsSelector({ selected = [], onChange, error }) {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOther, setShowOther] = useState(false);
  const [otherProvider, setOtherProvider] = useState("");

  useEffect(() => {
    const values = Array.isArray(selected) ? selected : [];
    const other = values.find(
      (v) => typeof v === "string" && v.startsWith("Other: "),
    );
    if (other) {
      setOtherProvider(other.substring(7));
      setShowOther(true);
    } else if (!values.includes("Other")) {
      setShowOther(false);
    }
  }, [selected]);

  useEffect(() => {
    loadDmsProviders();
  }, []);

  const loadDmsProviders = async () => {
    try {
      const data = await api.getMasterData("dms");
      console.log("DMS providers loaded:", data);
      setProviders(data || []);
    } catch (err) {
      console.error("Failed to load DMS providers:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (providerName) => {
    const current = Array.isArray(selected) ? selected : [];
    let newSelected;
    if (current.includes(providerName)) {
      newSelected = current.filter((p) => p !== providerName);
    } else {
      newSelected = [...current, providerName];
    }
    console.log("DMS selection changed:", newSelected);
    onChange(newSelected);
  };

  const handleOtherToggle = () => {
    if (showOther) {
      setShowOther(false);
      setOtherProvider("");
      // Remove "Other" from selected
      const current = Array.isArray(selected) ? selected : [];
      onChange(
        current.filter(
          (p) =>
            p !== "Other" &&
            !(typeof p === "string" && p.startsWith("Other: ")),
        ),
      );
    } else {
      setShowOther(true);
    }
  };

  const handleOtherChange = (e) => {
    const value = e.target.value;
    setOtherProvider(value);
    // Update selected with "Other"
    const current = Array.isArray(selected) ? selected : [];
    const cleaned = current.filter(
      (p) =>
        p !== "Other" && !(typeof p === "string" && p.startsWith("Other: ")),
    );
    if (value.trim()) {
      onChange([...cleaned, `Other: ${value.trim()}`]);
    }
  };

  if (loading) return <div>Loading DMS providers...</div>;

  // frontend/src/components/dms/DmsSelector.js - Updated render

  return (
    <div className="dms-selector">
      <label>DMS Providers</label>
      <div className="dms-grid">
        {providers.map((provider) => {
          const isSelected =
            Array.isArray(selected) && selected.includes(provider.name);
          return (
            <div
              key={provider.id}
              className={`dms-item ${isSelected ? "selected" : ""}`}
              onClick={() => handleToggle(provider.name)}
            >
              {provider.logo && <img src={provider.logo} alt={provider.name} />}
              <span>{provider.name}</span>
              {isSelected && <i className="fas fa-check-circle check-mark"></i>}
            </div>
          );
        })}
      </div>

      <div className="dms-other">
        <div className="other-item" onClick={handleOtherToggle}>
          <i className={`fas fa-${showOther ? "minus" : "plus"}`}></i>
          <span>Other</span>
          {otherProvider && (
            <span style={{ fontWeight: 400, color: "#6B7A8A" }}>
              : {otherProvider}
            </span>
          )}
        </div>
        {showOther && (
          <div className="other-input">
            <input
              type="text"
              className="form-control"
              placeholder="Enter DMS Provider Name"
              value={otherProvider}
              onChange={handleOtherChange}
            />
          </div>
        )}
      </div>

      {error && <div className="error-text">{error}</div>}
    </div>
  );
}

export default DmsSelector;
